import { Injectable } from '@angular/core';
import { ToastrManager } from "ng6-toastr-notifications";

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(private toastr: ToastrManager) { }

  omitValidateSpecialChar(event: { which: number }): boolean | string {
    const k = event.which;

    const allowedSpecialChars = [33, 36, 37, 58, 60, 61, 62, 63, 91, 92, 93, 94, 96, 123, 124, 125, 126];

    if (allowedSpecialChars.includes(k)) {
      //this.toastr.errorToastr('Special characters allowed  # * - _ ( ) /  “ + & @ ; .', 'Validation!');
      return false;
    }
    return true;
  }

  omitValidateSpecialCharString(input: KeyboardEvent | string): boolean | string {
    const allowedSpecialCharsRegex = /[a-zA-Z0-9#*_\-()/“+&@;.\s]/;

    if (typeof input === 'string') {
      return input.replace(/[^a-zA-Z0-9#*_\-()/“+&@;.\s]/g, '');
    } else {
      const k = input.charCode || input.keyCode;
      const isValid =
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        (k > 47 && k < 58) ||
        [35, 42, 45, 95, 40, 41, 47, 8220, 43, 38, 64, 59, 46].includes(k) ||
        k === 8 || k === 32;

      if (!isValid) {
        input.preventDefault();
      }
      return isValid;
    }
  }


  restrictSpecialInput(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode);

    // Allow only alphanumeric characters
    if (!/[a-zA-Z0-9]/.test(inputChar)) {
      event.preventDefault();
    }
  }

  omitSpecialChar(event: { charCode: any }): boolean {
    const k = event.charCode;
    return (k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k < 48 && k > 57);
  }

  removeSpaces(e: { currentTarget: { selectionStart: any; }; which: number; preventDefault: () => void; }) {
    const startPos = e.currentTarget.selectionStart;
    if ((e.which === 32 && startPos === 0) || (e.which === 13 && startPos === 0)) {
      e.preventDefault();
    }
  }

  omitSpecialCharNumberLastName(event: { charCode: any; }) {
    const k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k <= 48 && k >= 57) || k==190 || k==110 || k==46);
  }

  omitSpecialCharNumber(input: KeyboardEvent | string): boolean | string {
    if (typeof input === 'string') {
      return input.replace(/[^a-zA-Z\s]/g, '');
    } else {
      const k = input.charCode || input.keyCode;
      const isValid = ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32);
      if (!isValid) {
        input.preventDefault();
      }
      return isValid;
    }
}

allowAlphaNumericHyphen(input: KeyboardEvent | string): boolean | string {
  const allowedCharsRegex = /[a-zA-Z0-9\s\-]/;
  if (typeof input === 'string') {
    return input.replace(/[^a-zA-Z0-9\s\-]/g, '');
  } else {
    const k = input.charCode || input.keyCode;
    const isValid =
      (k > 64 && k < 91) ||       // A-Z
      (k > 96 && k < 123) ||      // a-z
      (k >= 48 && k <= 57) ||     // 0-9
      k === 8 ||                  // Backspace
      k === 32 ||                 // Space
      k === 45;                   // Hyphen

    if (!isValid) {
      input.preventDefault();
    }
    return isValid;
  }
}

allowAlphaNumeric(input: KeyboardEvent | string): boolean | string {
  const allowedCharsRegex = /[a-zA-Z0-9\s]/;
  if (typeof input === 'string') {
    return input.replace(/[^a-zA-Z0-9\s]/g, '');
  } else {
    const k = input.charCode || input.keyCode;
    const isValid =
      (k > 64 && k < 91) ||       // A-Z
      (k > 96 && k < 123) ||      // a-z
      (k >= 48 && k <= 57);

    if (!isValid) {
      input.preventDefault();
    }
    return isValid;
  }
}

  allowOnlyNumbers(input: KeyboardEvent | string): boolean | string {
    if (typeof input === 'string') {
      return input.replace(/[^0-9]/g, '');
    } else {
      const k = input.charCode || input.keyCode;
      const isValid = k >= 48 && k <= 57;
      if (!isValid) {
        input.preventDefault();
      }
      return isValid;
    }
  }


}
